import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MadAuthService } from "../../mad-auth/mad-auth.service";
import { SubdomainService } from "../../_base/subdomain.service";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { OutsetaPlanService } from "../../mad-auth/outseta-plan.service";
import { combineLatest } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ApproachToValueAPIService {
  constructor(
    private http: HttpClient,
    private authService: MadAuthService,
    private subdomainService: SubdomainService,
    private outsetaPlanService: OutsetaPlanService
  ) {}

  private _fetch() {
    return this.http.get<{data: Array<{
      id: number,
      name: string
    }>}>(environment.baseApiUrl + `api/v2/${this.subdomainService.subDomain}/approaches-to-value/listing`, {
      headers: this.authService.getAuthHeaders()
    }).pipe(
      map(response => response.data)
    )
  }

  fetchListing() {
    return combineLatest([
      this._fetch(),
      this.outsetaPlanService.allowedApproaches()
    ]).pipe(map(([items, allowedApproaches]) => {
      if (!items) return []
      return items.filter(item => allowedApproaches.includes(item.id))
    }))
  }
}